import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=96b9e62c&"
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/ai-contact/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96b9e62c')) {
      api.createRecord('96b9e62c', component.options)
    } else {
      api.reload('96b9e62c', component.options)
    }
    module.hot.accept("./submenu.vue?vue&type=template&id=96b9e62c&", function () {
      api.rerender('96b9e62c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutComponents/Menu/MenuLeft/partials/submenu.vue"
export default component.exports